import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { Col, Row, Modal } from "react-bootstrap";
import { generatePromoCodesAsync } from "../../redux/promoApi";

const GeneratePromoCodes = ({ showGenerateModal, setShowGenerateModal, isLoading }) => {
  const dispatch = useDispatch();

  const Schema = () =>
    Yup.object().shape({
      name: Yup.string().trim().min(2, "Minimum 2 characters").max(50, "Maximum 50 characters").required("Name is required"),
      freeCoins: Yup.number().min(0, "Must be >= 0").required("Free Coins is required"),
      maxUsage: Yup.mixed().test('is-number-or-empty', 'Must be a valid number', (val) => val === '' || val === null || val === undefined || !isNaN(Number(val))),
      count: Yup.number().min(1, "Must be at least 1").max(1000, "Too many").required("Count is required"),
    });

  const onHideModal = () => setShowGenerateModal(false);

  return (
    <>
      <Modal show={showGenerateModal} onHide={() => onHideModal()} centered className="def_modal delete_modal" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Generate Auto Promo Codes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{ name: '', freeCoins: 100, maxUsage: '', count: 10 }}
            validationSchema={Schema}
            onSubmit={(values) => {
              const payload = { ...values };
              if (payload.maxUsage === '' || payload.maxUsage === null || payload.maxUsage === undefined) {
                payload.maxUsage = 1;
              } else {
                payload.maxUsage = Number(payload.maxUsage);
              }
              dispatch(generatePromoCodesAsync(payload, setShowGenerateModal));
            }}
          >
            {({ values, errors, touched, handleChange, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Name</label>
                      <input
                        placeholder="Enter Name"
                        type="text"
                        name="name"
                        value={values.name}
                        className={errors.name && touched.name ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.name && errors.name ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.name}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Free Coins</label>
                      <input
                        placeholder="Enter Free Coins"
                        type="number"
                        name="freeCoins"
                        value={values.freeCoins}
                        className={errors.freeCoins && touched.freeCoins ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.freeCoins && errors.freeCoins ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.freeCoins}</div>
                        </div>
                      ) : null}
                    </div>



                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Generate Promo Codes</label>
                      <input
                        placeholder="e.g. 20"
                        type="number"
                        name="count"
                        value={values.count}
                        className={errors.count && touched.count ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.count && errors.count ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.count}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group  mb-0 mt-4">
                      <div className="form-group mr-5 mb-1 mt-2">
                        <button type="submit" className="btn btn-blue spinnerBtn add-avtar-btn" disabled={isLoading}>
                          <span>Generate</span>
                          {isLoading && (
                            <div className="ml-3 basic-verification-loader text-center">
                              <CircularProgress />
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GeneratePromoCodes; 